// Framework-free routing logic for the assessment "Edit" button so it can be
// unit-tested without a React/jest setup. Given a table row `record`, decide
// which editor to open:
//   - scheduled assessments  -> EditScheduleDrawer       (kind: 'schedule')
//   - everything else        -> EditAssessmentDrawer      (kind: 'assessment')
//   - unresolvable row       -> no-op                     (kind: 'none')
//
// A row is "scheduled" only when it has a scheduleId AND is neither one-time nor
// standalone. Corporate rows carry assessmentCorporateMapId. Institute rows
// resolve their map id from latestAssessmentInstituteMapId, then
// assessmentInstituteMapId, then the last assessmentDetails entry.
function resolveAssessmentEditTarget(record) {
  if (!record) return { kind: 'none' }

  const isScheduled = !!record.scheduleId && !record.isOneTime && !record.isStandalone
  if (isScheduled) {
    return { kind: 'schedule', scheduleId: record.scheduleId }
  }

  if (record.assessmentCorporateMapId) {
    return { kind: 'assessment', mapId: record.assessmentCorporateMapId, mapType: 'corporate' }
  }

  const details = record.assessmentDetails
  const lastDetail = Array.isArray(details) && details.length ? details[details.length - 1] : null
  const mapId =
    record.latestAssessmentInstituteMapId ||
    record.assessmentInstituteMapId ||
    (lastDetail && lastDetail.assessmentInstituteMapId)

  if (mapId) {
    return { kind: 'assessment', mapId, mapType: 'institute' }
  }

  return { kind: 'none' }
}

module.exports = { resolveAssessmentEditTarget }
